import classNames from "classnames";
import Button from "components/base/Button";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeFilterById, removeLocalFilter, selectLocalFilter } from "../../../../data/search";
import newsearchfilter from "./SearchFilterNew.scss";
import { ReactSVG } from "react-svg";
import SearchArrow from '../../../../assets/images/close-icon-gray.svg';
import FilterArrow from '../../../../assets/images/filter-left-arrow.svg';
import ShowAllButton from "./showAllButton";

export const AppliedFilterSection = () => {
  const getLocalFilter = useSelector(selectLocalFilter);
  const dispatch = useDispatch();

  const [getFilter, setFilter] = useState([]);
  const ref = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  useEffect(() => {
    setFilter(getLocalFilter);
  }, [getLocalFilter]);

  const handleClearFilter = (id) => {
    dispatch(removeLocalFilter(id));
  };

  const handleOldRemoveFilter = (id) => {
    dispatch(removeFilterById(id));
  };

  useEffect(() => {
    const container = ref.current;
    if (!container) return;

    const scrollThreshold = 0.7; 

    setShowLeftArrow(container.scrollLeft > 0);
    setShowRightArrow(container.scrollLeft  < (container.scrollWidth - container.clientWidth) * (1 - scrollThreshold));

    // Add event listener for scroll
    const handleScroll = () => {
      setShowLeftArrow(container.scrollLeft > 0);
      setShowRightArrow(container.scrollLeft  < (container.scrollWidth - container.clientWidth) * (1 - scrollThreshold));
    };
    container.addEventListener('scroll', handleScroll);

    // Cleanup function
    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [getFilter]); // Trigger effect on filter change

  return (
    <>
      {getFilter && getFilter.length > 0 ? (
        <div className={newsearchfilter.clsBotHeader}>
          <div className={newsearchfilter.clsFilterScroll}>
            {showLeftArrow && (
              <span className={classNames(newsearchfilter.clsFilterLftArrow)} onClick={() => ref.current.scrollTo({ left: ref.current.scrollLeft - ref.current.clientWidth, behavior: 'smooth' })}>
                <ReactSVG src={FilterArrow} className={newsearchfilter.clsFilterArrow} />
              </span>
            )}
            <ul className={newsearchfilter.clsFilterList} ref={ref}>
              {getFilter.slice().reverse().map((filterKey, index) => (
                <li key={index}>
                  {filterKey?.id}: {filterKey?.name}
                  <Button
                    kind="link-default"
                    name="clear"
                    className={newsearchfilter.clsListClearBtn}
                    onClick={() => {
                      handleClearFilter(filterKey?.id);
                      handleOldRemoveFilter(filterKey.removeID);
                    }}
                  >
                    <ReactSVG src={SearchArrow} className={newsearchfilter.clsListClearIcon} />
                  </Button>
                </li>
              ))}
            </ul>
            {showRightArrow && (
              <span className={classNames(newsearchfilter.clsFilterLftArrow, newsearchfilter.clsFilterRitArrow)} onClick={() => ref.current.scrollTo({ left: ref.current.scrollLeft + ref.current.clientWidth, behavior: 'smooth' })}>
                <ReactSVG src={FilterArrow} className={newsearchfilter.clsFilterArrow} />
              </span>
            )}
          </div>
          <div className={newsearchfilter.clsShowAllBtnDiv}>
            <ShowAllButton />
          </div>
        </div>
      ) : null}
    </>
  );
};
